import React from 'react';

const OurStory: React.FC = () => {
    return (
        <section className="bg-white py-24 md:py-32 px-6">
            <div className="max-w-2xl mx-auto">
                <p className="font-sans text-[10px] md:text-xs tracking-[0.4em] uppercase text-dry_sage mb-4">
                    о нас
                </p>
                <h2 className="font-script text-4xl md:text-6xl text-prussian_blue mb-6">Наша история</h2>
                <div className="flex items-center justify-center gap-3 mb-12 divider-ornament-green max-w-xs mx-auto">
                    <span className="text-dry_sage text-xl animate-heart">♥</span>
                </div>
                <p className="font-sans text-base md:text-lg text-prussian_blue/70 leading-relaxed max-w-xl mx-auto">
                    Когда-то судьба свела нас вместе, и мы поняли, что искали друг друга всю жизнь.
                    Наша встреча переросла в крепкую дружбу, а дружба — в огромную любовь.
                </p>
                <p className="font-sans text-base md:text-lg text-prussian_blue/70 leading-relaxed max-w-xl mx-auto mt-8">
                    Каждый из вас — важная часть нашей жизни, именно поэтому мы с огромной радостью
                    приглашаем вас стать свидетелями рождения нашей новой семьи
                    и вместе создать этот светлый и незабываемый день.
                </p>
            </div>
        </section>
    );
};

export default OurStory;

